module.exports = __webpack_public_path__ + "static/media/warning.35e3ed6f.svg";